<template>
  <main
    class="bg-white dark:bg-zinc-950 text-zinc-900 dark:text-zinc-100 theme-transition"
  >
    <slot />
  </main>
</template>
